<script lang="ts">
import type { PropType, VNode } from "vue";
import { defineComponent, h } from "vue";
import type { BmGridColumnConfiguration } from "@/components/controls/grid/BmGridData";

/**
 * Thin render wrapper around column.renderer — keeps the CreateElement-based
 * column API without redesigning it for Vue 3 yet.
 */
export default defineComponent({
  name: "BmGridContentCell",
  props: {
    column: {
      type: Object as PropType<BmGridColumnConfiguration>,
      required: true,
    },
    item: {
      required: true,
    },
    align: {
      type: Boolean,
      default: true,
    },
  },
  render(): VNode {
    const column = this.column;
    const item = this.item;
    const align = this.align;
    const classes = column.classExtractor(item);
    const node = column.renderer(
      h,
      column.extractAndFormat(item),
      item,
      column
    );
    const isContentCell = !column.rendererMetadata.actions;
    return h(
      "div",
      {
        class: {
          "content-cell": isContentCell,
          "no-print": !isContentCell,
          "d-flex": align,
          "text-center justify-center": column.align === "center" && align,
          "text-right justify-end": column.align === "end" && align,
          [classes]: !!classes,
        },
      },
      [node]
    );
  },
});
</script>

<style scoped lang="sass">
// Pad out content cells to match parents and give spacing
.content-cell
  padding: 8px
  overflow: hidden
  text-overflow: ellipsis
</style>
